export const CacheDurations = {
  SHORT: 5 * 60, // = 5 minutes.
  MEDIUM: 10 * 60, // = 10 minutes.
  LONG: 30 * 60, // = 30 minutes.
  XLONG: 60 * 60, // = 1 hour.
} as const;
